/* ============
 * Organization Member Transformer
 * ============
 *
 * The transformer for the organization type.
 */

import Transformer from './transformer';

export default class OrganizationMemberBookingTransformer extends Transformer {
  static fetch(organizationMemberBooking) {
    return {
      id: organizationMemberBooking.id,
      order: organizationMemberBooking.order,
      organizationMemberProduct: organizationMemberBooking.organization_member_product,
      date: organizationMemberBooking.date,
      startTime: organizationMemberBooking.start_time,
      endTime: organizationMemberBooking.end_time,
      status: organizationMemberBooking.status,
    };
  }

  static send(organizationMemberBooking) {
    return {
      id: organizationMemberBooking.id,
      product_id: organizationMemberBooking.product_id,
      member_id: organizationMemberBooking.member_id,
      client_id: organizationMemberBooking.client_id,
      date: organizationMemberBooking.date,
      start_time: organizationMemberBooking.start_time,
      order_number: organizationMemberBooking.order_number,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/organizationMemberBooking.js